import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-puzzle"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      class: "icon-fi--no-fill icon-fi--filled"
    }, null, -1),
    _createElementVNode("g", {
      transform: "translate(10425.095 -18291.891)",
      class: ""
    }, [
      _createElementVNode("path", {
        d: "M-10414.2,18305.3l11.4-3.4l4.8,1.6c-0.6,0.3-0.9,0.9-0.9,1.5c0.8-0.2,3.2-0.8,3.2-0.8l4.7,1.6\n\t\tl-0.1,5.9l-5.3,1.9l5.3,1.9v6l-11.4,4.4l-4.6-1.9v-1.4c0.9-1,0.9-2.6-0.1-3.6c-0.4-0.3-0.8-0.5-1.3-0.6c-2.1-0.6-3.3,1.9-1.9,3.8\n\t\tv0.6l-3.6-1.4l-0.1-6.1c0,0,0.3,0.1,0.6,0.2c0.6,2.1,2.9,1.2,2.9-0.7c0-2.5-1.8-3.5-2.9-2.4l-0.6-0.2L-10414.2,18305.3z",
        class: "icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M-10414.6,18305.5l4.7,1.6v1.4c-0.7,1.2-0.2,2.8,1,3.5c0.1,0,0.2,0.1,0.3,0.1\n\t\tc1.5,0.5,2.4-1.6,1.3-2.9v-1.3l4.7,1.6v6.4c0,0-0.8-0.2-1.2-0.3c-0.5-1.2-2.5-1-2.5,1c0,2.7,1.6,2.7,2.5,2.1l1.2,0.3v6.9",
        class: "icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }